// extracted by mini-css-extract-plugin
export var compactFilters = "_d7-4";
export var detailImage = "_d7-1";
export var dropdownContainer = "_d7-2";
export var imageContainer = "_d7-0";
export var selectedCard = "_d7-3";